import { Box, Typography } from '@mui/material';
import React from 'react';
import useMessagesStore from '../../state-files/useMessagesStore';
import { useNavigate } from 'react-router-dom';
import useStore from '../../state-files/zustondStoreStates';
import extractChatMessages from '../../helper-methods/fetchAndRefreshMessages';
import fetchDiscussions from '../../helper-methods/fetchDiscussions';

const SidebarGetList = ({ itemList, isExpanded }) => {
    const [currentUser] = React.useState(localStorage.getItem('userId'));
    const { setMessageList } = useMessagesStore();
    const { currentCommunityId, setChatId, setCurrentCommunityId, setCommunityId, setCurrentCommunityName, setSidebarList } = useStore();
      const setDiscussions = useStore((state) => state.setDiscussions);
    const navigate = useNavigate();

    const fetchChatMessages = async (discussionId) => {
        setChatId(discussionId);
        setMessageList(extractChatMessages(discussionId, currentCommunityId));
        navigate('/chat')
    };

      const fetchDiscussionList = async (communityId, communityName) => {
        setCommunityId(communityId);
        setCurrentCommunityName(communityName);
        fetchDiscussions(setDiscussions, communityId);
        setCurrentCommunityId(communityId);
        navigate('/discussions');
      };

    return (
        <Box className={isExpanded ? '' : 'hidden'} sx={{ gap: 0.5 }}>
            {itemList
                .sort((a, b) => {
                    const priorityId = "69769ec2f601532a29c0a0a3"; //This is the introduction channel

                    // 1. If 'a' is the priority ID, move it to the top
                    if (a.id === priorityId) return -1;
                    // 2. If 'b' is the priority ID, move it to the top
                    if (b.id === priorityId) return 1;

                    // 3. Otherwise, sort the rest alphabetically by title
                    return (a.title || "").localeCompare(b.title || "");
                })
                .map((item, index) => {
                    return (
                        <Typography sx={{ cursor: 'pointer', marginTop: 0.6 }} onClick={() => {
                            if (item.title !== undefined || item.title === 'undefined') {
                                fetchChatMessages(item.id)
                            } else {
                                fetchDiscussionList(item.id, item.name)
                            }
                        }}>{item.title || item.name}</Typography>
                    )
                })}
        </Box>
    )
};

export default SidebarGetList;